import { Pipe, PipeTransform } from '@angular/core';
import { CurrencyType } from '@shared/enums/CurrencyType';

@Pipe({
    name: 'currencyLabel'
})
export class CurrencyLabelPipe implements PipeTransform {
    transform(currencyType: CurrencyType): string {
        let currencyLabel = '';

        switch (currencyType) {
            case CurrencyType.AUD:
                currencyLabel = 'AUD';
                break;
            case CurrencyType.CAD:
                currencyLabel = 'CAD';
                break;
            case CurrencyType.CHF:
                currencyLabel = 'CHF';
                break;
            case CurrencyType.EUR:
                currencyLabel = 'EUR';
                break;
            case CurrencyType.GBP:
                currencyLabel = 'GBP';
                break;
            case CurrencyType.NOK:
                currencyLabel = 'NOK';
                break;
            case CurrencyType.SEK:
                currencyLabel = 'SEK';
                break;
            case CurrencyType.USD:
                currencyLabel = 'USD';
                break;
        }

        return currencyLabel;
    }
}

@Pipe({
    name: 'currency'
})
export class CurrencyPipe implements PipeTransform {
    transform(value: number, currency: 'EUR' | 'USD' | 'ZAR' | 'GBP'): any {
        const formattedAmount = value.toFixed(2)
            .replace('.', ',')
            .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');

        switch (currency) {
            case 'EUR':
                return `€${formattedAmount}`;
            case 'USD':
                return `$${formattedAmount}`;
            case 'ZAR':
                return `R${formattedAmount}`;
            case 'GBP':
                return `£${formattedAmount}`;
            default:
                return formattedAmount;
        }
    }
}
